import PhotoContainer from '../src/PhotoContainer.tsx';
export default PhotoContainer;
